import { EJHEALTH_COLORS, EJHEALTH_TYPE } from "@/lib/theme/ej-health";

/** Inline rectangular eyebrow chip used over images / cards. */
export function CategoryEyebrow({ label }: { label: string }) {
  return (
    <span
      style={{
        ...EJHEALTH_TYPE.eyebrow,
        color: EJHEALTH_COLORS.accentDark,
      }}
    >
      {label}
    </span>
  );
}
